import { render, staticRenderFns } from "./InternationalArchitectureAwardFrame.vue?vue&type=template&id=60136bef"
import script from "./InternationalArchitectureAwardFrame.vue?vue&type=script&lang=js"
export * from "./InternationalArchitectureAwardFrame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/home/bazzite/Work/awardapplication/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60136bef')) {
      api.createRecord('60136bef', component.options)
    } else {
      api.reload('60136bef', component.options)
    }
    module.hot.accept("./InternationalArchitectureAwardFrame.vue?vue&type=template&id=60136bef", function () {
      api.rerender('60136bef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/modules/international-architecture-award/components/InternationalArchitectureAwardFrame.vue"
export default component.exports